import type { DatasetInstanceConfig } from '../../data-builder.store';

export function hasCompanyUnitOfAnalysisScope(
  config: DatasetInstanceConfig
): boolean {
  if (config.unitOfAnalysis !== 'company') {
    return false;
  }
  return (
    Object.keys(config.companySelections).length > 0 ||
    (config.companySets !== null && config.companySets.length > 0) ||
    config.companyMapper !== null
  );
}
